<mat-card appearance="outlined" class="syn-card">
    <mat-card-header fxLayout="row" class="header">
        <mat-card-title class="title">Notes</mat-card-title>
        <div *ngIf="!isEditing" fxFlexAlign="end" fxLayoutGap="10px">
            <a *ngIf="editable" mat-menu-item (click)="startEditing()">
                <mat-icon svgIcon="pencil-outline"></mat-icon>
                <span>Modifier</span>
            </a>
        </div>
    </mat-card-header>
    <mat-card-content>
        <div *ngIf="content && !isEditing" fxLayout="column">
            <syn-markdown fxFlex="auto" [data]="content"></syn-markdown>
        </div>
        <div
            *ngIf="!content && !isEditing"
            fxLayout="row"
            fxLayout.lt-md="column"
            fxLayoutAlign="start center"
            fxLayoutGap="20px"
        >
            <div>{{ emptyLabel }}</div>
        </div>
        <div *ngIf="isEditing" fxLayout="column">
            <mat-form-field appearance="outline" fxFlex="auto">
                <mat-label
                    >{{ editLabel }}
                    <mat-icon svgIcon="file-document-outline"></mat-icon>
                </mat-label>
                <textarea
                    matInput
                    [(ngModel)]="tmp"
                    style="height: 315px"
                ></textarea>
            </mat-form-field>
            <div fxLayout="row" fxFlexAlign="end" fxLayoutGap="10px">
                <button mat-button (click)="endEditing()">Annuler</button>
                <button mat-raised-button (click)="update()" color="accent">
                    Sauvegarder les notes
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>
